function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Flex, HStack, Heading, Icon, IconButton, Link as ChakraLink, Stack } from '@chakra-ui/react';
import { Link, useNavigate } from 'react-router';
import React from 'react';
import LogoText from '../LogoText';
import { ExternalUrls, WebRoutes } from '@/utils/constants';
import { FormattedMessage, useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDiscord, faXTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';
export default function LandingFooter(props) {
    var navigate = useNavigate();
    return /*#__PURE__*/ _jsxs(Flex, _object_spread_props(_object_spread({
        color: "textPrimary",
        justifyContent: "space-between",
        width: "100%",
        flexDirection: {
            base: 'column',
            md: 'row'
        },
        gap: 8,
        alignItems: "flex-start"
    }, props), {
        children: [
            /*#__PURE__*/ _jsxs(Stack, {
                spacing: 4,
                flex: 1,
                children: [
                    /*#__PURE__*/ _jsx(LogoText, {
                        padding: 0,
                        color: "textPrimary"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        size: "sm",
                        variant: "cta",
                        width: "fit-content",
                        onClick: function() {
                            return navigate(WebRoutes.DASHBOARD);
                        },
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "OtVW5B",
                            defaultMessage: "Add to Chat"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Stack, {
                flex: 1,
                children: [
                    /*#__PURE__*/ _jsx(Heading, {
                        size: "sm",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "hzSNj4",
                            defaultMessage: "Dashboard"
                        })
                    }),
                    /*#__PURE__*/ _jsx(ChakraLink, {
                        as: Link,
                        to: WebRoutes.DASHBOARD,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "ejEGdx",
                            defaultMessage: "Home"
                        })
                    }),
                    /*#__PURE__*/ _jsx(ChakraLink, {
                        as: Link,
                        to: WebRoutes.COMMANDS,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "TY8Ho1",
                            defaultMessage: "Commands"
                        })
                    }),
                    /*#__PURE__*/ _jsx(ChakraLink, {
                        as: Link,
                        to: WebRoutes.TIMERS,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "q5NYii",
                            defaultMessage: "Timers"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Stack, {
                flex: 1,
                children: [
                    /*#__PURE__*/ _jsx(Heading, {
                        size: "sm",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "HqRNN8",
                            defaultMessage: "Support"
                        })
                    }),
                    /*#__PURE__*/ _jsx(ChakraLink, {
                        href: ExternalUrls.COMMUNITY_FORUM,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "XxAinn",
                            defaultMessage: "Community Forum"
                        })
                    }),
                    /*#__PURE__*/ _jsx(ChakraLink, {
                        href: ExternalUrls.DISCORD,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "FvmV6q",
                            defaultMessage: "Discord"
                        })
                    }),
                    /*#__PURE__*/ _jsx(ChakraLink, {
                        href: ExternalUrls.API_DOCS,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "yKOyCk",
                            defaultMessage: "API Documentation"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Stack, {
                flex: 1,
                children: [
                    /*#__PURE__*/ _jsx(Heading, {
                        size: "sm",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "7oFrM6",
                            defaultMessage: "Legal"
                        })
                    }),
                    /*#__PURE__*/ _jsx(ChakraLink, {
                        as: Link,
                        to: WebRoutes.TERMS,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "32rBNK",
                            defaultMessage: "Terms of Service"
                        })
                    }),
                    /*#__PURE__*/ _jsx(ChakraLink, {
                        as: Link,
                        to: WebRoutes.PRIVACY,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "vx0nkZ",
                            defaultMessage: "Privacy Policy"
                        })
                    })
                ]
            })
        ]
    }));
}
export function SocialFooter(props) {
    var intl = useIntl();
    return /*#__PURE__*/ _jsxs(HStack, _object_spread_props(_object_spread({
        color: "textSecondary",
        justifyContent: "space-between",
        width: "100%",
        spacing: 4,
        paddingY: 4
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(FormattedMessage, {
                id: "Cs32ER",
                defaultMessage: "Copyright \xa9 {year} NightDev, LLC. All Rights Reserved",
                values: {
                    year: new Date().getFullYear()
                }
            }),
            /*#__PURE__*/ _jsxs(HStack, {
                children: [
                    /*#__PURE__*/ _jsx(IconButton, {
                        icon: /*#__PURE__*/ _jsx(Icon, {
                            as: FontAwesomeIcon,
                            icon: faDiscord
                        }),
                        "aria-label": intl.formatMessage({
                            id: "es45bQ",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Join our Discord"
                                }
                            ]
                        }),
                        variant: "ghost",
                        onClick: function() {
                            return window.open(ExternalUrls.DISCORD, '_blank');
                        }
                    }),
                    /*#__PURE__*/ _jsx(IconButton, {
                        icon: /*#__PURE__*/ _jsx(Icon, {
                            as: FontAwesomeIcon,
                            icon: faXTwitter
                        }),
                        "aria-label": intl.formatMessage({
                            id: "8itImv",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Follow us on X"
                                }
                            ]
                        }),
                        variant: "ghost",
                        onClick: function() {
                            return window.open(ExternalUrls.X, '_blank');
                        }
                    }),
                    /*#__PURE__*/ _jsx(IconButton, {
                        icon: /*#__PURE__*/ _jsx(Icon, {
                            as: FontAwesomeIcon,
                            icon: faYoutube
                        }),
                        "aria-label": intl.formatMessage({
                            id: "eObXfZ",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Subscribe to us on YouTube"
                                }
                            ]
                        }),
                        variant: "ghost",
                        onClick: function() {
                            return window.open(ExternalUrls.YOUTUBE, '_blank');
                        }
                    })
                ]
            })
        ]
    }));
}
